<template>
<div>
    <div class="mobile-body"></div>
    <div class="link-details text-center">
        <router-link class="brand" to="/">
            <img class="logo-img" src="../assets/images/culture-logo.png" alt="" />
        </router-link>
        <div class="">Welcome to Culture Square</div>
        <ul class="d-inline-flex links ml-2">
            <router-link to="">
                <li>Sell - </li>
            </router-link>
            <router-link to="/listings">
                <li>Buy - </li>
            </router-link>
            <router-link to="/listings/event/create">
                <li>Host Events - </li>
            </router-link>
            <router-link to="">
                <li>Attend Event </li>
            </router-link>
        </ul>
    </div>

</div>
</template>

<script>
export default {
    name: 'abstract-header'
}
</script>

<style lang="scss" scoped>
.mobile-body {
    background-image: url('../assets/images/mobile-abstract.svg');
    background-repeat: no-repeat;
    background-size: cover;
    height: 22vh;
}

.link-details {
    margin-top: 40px
}

ul.links li {
    padding: 5px;
}

a {
    color: #333333
}
</style>
